import { motion } from "framer-motion";
import { KeyRound, Ruler, MoveHorizontal, Undo2 } from "lucide-react";

const perks = [
  {
    icon: KeyRound,
    title: "No account, ever",
    body: "Your FitKey is a pass in Apple or Google Wallet. It is your identity — no password, no login.",
  },
  {
    icon: Ruler,
    title: "Brand-accurate, not a formula",
    body: "Your size is mapped through each brand's real size chart. Not one blanket EU number.",
  },
  {
    icon: MoveHorizontal,
    title: "Width included",
    body: "Where a brand offers widths (2A to 4E), you see which ones exist for your pair.",
  },
  {
    icon: Undo2,
    title: "Fit checks and returns",
    body: "After you buy, confirm the fit or request a return right from the pass.",
  },
];

export default function ForShoppers() {
  return (
    <section
      id="for-shoppers"
      data-testid="for-shoppers-section"
      className="relative py-24 md:py-28 bg-[#FAFAFA]"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-12 md:mb-16">
          <div className="md:col-span-4">
            <div className="inline-flex items-center gap-2 text-[11px] tracking-[0.22em] uppercase text-neutral-500">
              <span className="h-px w-8 bg-black/40" />
              For shoppers
            </div>
          </div>
          <h2
            data-testid="for-shoppers-headline"
            className="md:col-span-8 text-4xl sm:text-5xl lg:text-6xl tracking-[-0.035em] font-medium leading-[1.02]"
          >
            One pass in your Wallet. <span className="text-neutral-400">Your size everywhere.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {perks.map((p, i) => (
            <motion.div
              key={p.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`shopper-perk-${i + 1}`}
              className="rounded-2xl border border-black/10 bg-white p-6 hover:-translate-y-1 transition-all duration-500"
            >
              <div className="h-10 w-10 rounded-xl border border-black/10 bg-[#FAFAFA] grid place-items-center">
                <p.icon className="h-4 w-4 text-[#0A0A0A]" strokeWidth={1.5} />
              </div>
              <div className="mt-6 text-[17px] tracking-tight font-medium">{p.title}</div>
              <p className="mt-2 text-[13.5px] text-neutral-600 leading-relaxed">{p.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
